import isObject from '../utility/isObject';

class Product {
  public static fragmentsFields(): string {
    return `
      id
      name
      imageUrl
      price
      taxPercent
      taxType
      taxPrice
      categoryId
      ecTopImageUri
      ecTitle
      ecDescription
    `;
  }

  public static fromJson(value: any): Product {
    if (!isObject(value)) {
      throw new TypeError('value must be an object for Product.fromJson(value).');
    }

    const id = value['id'];
    const name = value['name'];
    const imageUrl = value['imageUrl'];
    const price = value['price'];
    const taxPercent = value['taxPercent'];
    const taxPrice = value['taxPrice'];
    const taxType = value['taxType'];
    const ecTopImageUri = value['ecTopImageUri'];
    const ecTitle = value['ecTitle'];
    const ecDescription = value['ecDescription'];
    const categoryId = value['categoryId'];
    const count = value['count'];

    if (typeof id !== 'string') {
      throw new TypeError('value.id must be a string for Product.fromJson(value).');
    }

    if (typeof name !== 'string') {
      throw new TypeError('value.name must be a string for Product.fromJson(value).');
    }

    return new Product({
      id,
      name,
      imageUrl,
      categoryId,
      price,
      taxPercent,
      taxPrice,
      taxType,
      ecTopImageUri,
      ecTitle,
      ecDescription,
      count,
    });
  }

  public id: string;
  public name: string;
  public imageUrl: string;
  public price: number;
  public taxPercent: number;
  public taxPrice: number;
  public taxType: string;
  public categoryId: string;
  public ecTopImageUri: string;
  public ecTitle: string;
  public ecDescription: string;
  public count: number;

  constructor({
    id = '',
    name = '',
    imageUrl = '',
    price = 0,
    taxPercent = 0,
    taxPrice = 0,
    taxType = 'default_store',
    categoryId = '',
    ecTopImageUri = '',
    ecTitle = '',
    ecDescription = '',
    count = 0,
  }: {
    id?: string;
    name?: string;
    imageUrl?: string;
    price?: number;
    taxPercent?: number;
    taxPrice?: number;
    taxType?: string;
    categoryId?: string;
    ecTopImageUri?: string;
    ecTitle?: string;
    ecDescription?: string;
    count?: number;
  }) {
    this.id = id;
    this.name = name;
    this.imageUrl = imageUrl;
    this.price = price;
    this.taxPercent = taxPercent;
    this.taxPrice = taxPrice;
    this.taxType = taxType;
    this.categoryId = categoryId;
    this.ecTopImageUri = ecTopImageUri;
    this.ecTitle = ecTitle;
    this.ecDescription = ecDescription;
    this.count = count;
  }

  public displayTitle() {
    return this.ecTitle || this.name
  }

  public displayImage() {
    return this.ecTopImageUri || this.imageUrl
  }
}

export default Product;
